module.exports = __webpack_public_path__ + "ce494d5be7e464b5f6a77049fe4fb665.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thbc-mn.png
// module id = 2016
// module chunks = 0